import {ReactNode, MouseEvent} from 'react';

import {TestIdProps} from 'shared/web';

export type ButtonProps = {
  icon?: ReactNode;
  brand?: ReactNode;
  type?: 'button' | 'submit';
  compact?: boolean;
  disabled?: boolean;
  active?: boolean;
  iconRight?: boolean;
  onlyIcon?: boolean;
  primary?: boolean;
  secondary?: boolean;
  danger?: boolean;
  outlined?: boolean;
  transparent?: boolean;
  normal?: boolean;
  children?: ReactNode;
  className?: string;
  isLoading?: never;
  onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
  href?: string;
} & TestIdProps;

export type IconProps = {
  icon?: boolean;
  iconRight?: boolean;
  onlyIcon?: boolean;
};
